import { Segment } from '@/components/inventory-toolbar';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useScenarioId } from '@/hooks/use-scenario-id';
import { useGetScenarioQuery } from '@/api/scenarios';

const ToolbarScenario = () => {
  const inventoryId = useInventoryId();
  const scenarioId = useScenarioId();
  const { data: scenario, isSuccess } = useGetScenarioQuery(scenarioId);

  return isSuccess ? (
    <Segment
      to={`/communities/${inventoryId}/pathways/${scenarioId}`}
      label={scenario.name}
    />
  ) : null;
};

export { ToolbarScenario };
